<script>
export default {
  name: "TheMeetingStatementInformationDialog",

  props: {
    visible: Boolean,
  },

  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close')
        }
      }
    },
  },
}
</script>

<template>
  <v-dialog
    v-model="show"
    width="600px"
    content-class="rounded-xl"
  >
    <v-card class="rounded-xl">
      <v-card-title>
        <span class="text-h5">Работа с заявлением участника</span>
      </v-card-title>

      <v-card-title>
        <span class="text-h5">Система голосования</span>
      </v-card-title>

      <v-card-text>
        <div>
          Процесс редактирования типа деятельности, параметров и удаления достижений в заявлении основан на принципе голосования абсолютным большинством.
          При инициации любого из этих действий участниками комиссии, включая председателя,
          слушателей и председателя студенческого актива (при условии, что он сам не участвует в конкурсе), начинается процесс голосования.
        </div>
        <div class="my-1"></div>
        <div>
          В случае равенства голосов, решающим становится голос председателя комиссии.
          Голосование проводится с использованием кнопок “за” и “против”, расположенных в специальных окнах.
          Если в заявлении участника присутсвует голосование, оно отображается специальным символом <v-icon small color="error">fa-comment</v-icon>, на который можно нажать.
        </div>
        <div class="my-1"></div>
        <div>
          К каждому голосованию прикрепляется комментарий, а также указывается ФИО инициатора голосования.
          При удалении достижения член комиссии обязан указать причину удаления в комментарии.
          Для редактирования типа деятельности и параметров достижения комментарий генерируется автоматически по шаблону:
          “старые данные заменяются на новые данные”.
        </div>
      </v-card-text>

      <v-card-title>
        <span class="text-h5">Общие сведения</span>
      </v-card-title>

      <v-card-text>
        <span class="text-h6">Редактирование типа деятельности заявления</span>
        Комиссия может изменить тип деятельности кандидата посредством голосования. Для этого комиссии необходимо нажать на кнопку <v-icon small>fa-edit</v-icon>,
        расположенную в блоке с названием типа деятельности, выбранного участником.
      </v-card-text>

      <v-card-text>
        <span class="text-h6">Редактирование параметров достижений</span>
        Комиссия может изменить параметры достижения, прикрепленного к заявлению, путем голосования.
        Для этого в карточке достижения необходимо нажать на соответствующую кнопку,<v-icon small color="teal darken-3">fa-edit</v-icon>,
        и выбрать новые параметры в раскрывшемся диалоговом окне.
      </v-card-text>

      <v-card-text>
        <span class="text-h6">Удалить достижение из заявления</span>
        Комиссия может удалить достижение из заявления путем голосования.
        Для этого необходимо нажать на соответствующую кнопку
        на карточке достижения и ввести причину удаления в появившемся диалоговом окне.
      </v-card-text>

      <v-card-text>
        <span class="text-h6">Альтернативный вид просмотра достижений</span>
        При нажатии на кнопку с надписью “Посмотреть”, открывается окно, которое позволяет
        просматривать достижения, указанные в заявлении, в альтернативном виде.
        В этом представлении слева отображается прикрепленный файл, а справа - карточка с параметрами, введенными участником для данного достижения,
        а также комментарий с голосованиемы, если он есть для данного достижения.
        Это обеспечивает удобство и эффективность в процессе оценки достижений.
        Также в данном виде присутствуют кнопки для редактирования и удаления достижений.
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="teal darken-3"
          class="rounded-xl white--text"
          @click="show = false"
        >
          Закрыть
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>

</style>